<template>
  <div class="loader-container">
    <div class="loader"></div>
  </div>
</template>

<style>
/* 로더 스타일 */
.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
}

.loader {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translateX(-50%, -45%);
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-left-color: #3498db;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
